import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography
} from '@mui/material';

export default function MissingProfileIdDialog({ open, onSave, onClose }) {
  const [value, setValue] = useState('');

  const handleSave = () => {
    const n = Number(value);
    if (Number.isFinite(n) && n > 0) {
      onSave(n);
    } else {
      alert('Inserisci un ID numerico valido (>0).');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Completa il tuo profilo</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          Non siamo riusciti a individuare automaticamente il tuo profilo.
          Inserisci il tuo <strong>ID utente</strong> per continuare.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="freelancerId"
          placeholder="es. 12"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button variant="contained" onClick={handleSave}>
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
}
